import * as React from "react";
import { SVGProps } from "react";
const SvgLogoDefault = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={18}
    height={18}
    viewBox="0 0 14 14"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <path
        d="M12.354 3.081c.124.302.348.524.667.593l.479.122v.658l-.48.122c-.319.07-.501.29-.626.592a.995.995 0 0 0 .082.919l.31.481-.464.46-.483-.321a1.005 1.005 0 0 0-.92-.104c-.302.125-.524.349-.593.667l-.122.48h-.658l-.122-.48c-.07-.319-.29-.501-.592-.626a.997.997 0 0 0-.919.082l-.481.31-.46-.464.321-.484a1 1 0 0 0 .104-.92c-.125-.301-.349-.523-.668-.592l-.479-.122v-.658l.479-.122c.319-.069.502-.29.627-.591a.995.995 0 0 0-.082-.92l-.311-.48.464-.46.484.321c.275.176.619.228.92.103.301-.125.524-.349.593-.667L9.546.5h.658l.122.48c.069.318.29.5.592.626a.997.997 0 0 0 .919-.083l.481-.31.46.464-.322.484a1 1 0 0 0-.102.92ZM9.875 5.938a1.813 1.813 0 1 0 0-3.626 1.813 1.813 0 0 0 0 3.626Z"
        fill="#FF9210"
      />
      <path
        d="M6.603 8.831c.125.302.349.524.668.593l.479.122v.658l-.48.122c-.319.07-.501.29-.626.592a.995.995 0 0 0 .082.919l.31.481-.464.46-.483-.322a1.005 1.005 0 0 0-.92-.102c-.302.124-.524.348-.593.667l-.122.479h-.658l-.122-.48c-.07-.319-.29-.501-.592-.626a.997.997 0 0 0-.919.082l-.481.31-.46-.464.321-.484a1 1 0 0 0 .104-.92c-.125-.301-.349-.523-.668-.592L.5 10.204v-.658l.479-.122c.319-.069.502-.29.627-.591a.995.995 0 0 0-.082-.92l-.311-.48.464-.46.484.321c.275.176.619.228.92.103.301-.125.524-.349.593-.667l.122-.48h.658l.122.48c.069.318.29.5.592.626a.997.997 0 0 0 .919-.083l.481-.31.46.464-.321.484a1 1 0 0 0-.104.92Zm-2.478 2.857a1.813 1.813 0 1 0 0-3.626 1.813 1.813 0 0 0 0 3.626Z"
        fill="#3EAC40"
      />
    </g>
  </svg>
);
export default SvgLogoDefault;
